import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  ListAccountsAPIError,
  ListAccountsAPIVariables,
  fetchListAccountsAPI,
} from '../toolkitComponents.js';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.js';
import { Registry } from './registry.js';

type Response = z.infer<typeof schema>;
const { schema } = Registry.listAccountsAPI;

export function useListAccountsAPI(
  variables: ListAccountsAPIVariables,
  opts?: UseQueryOptions<Response, ListAccountsAPIError>,
): UseQueryResult<Response> {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<Response, ListAccountsAPIError>(
    queryKeyFn({
      path: '/api/v2/admin/accounts',
      operationId: 'listAccountsAPI',
      variables,
    }),
    async () => {
      const res = await fetchListAccountsAPI({ ...fetcherOptions, ...variables });
      return schema.parse(res);
    },
    opts,
  );
}
